import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from './auth/services/auth.service';
import {SchemaBootstrapService, SchemaBootstrapState} from './services/schema-bootstrap.service';
import {StartupService} from './startup.service';

@Component({
  selector: 'root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'app';
  bootstrap$: Observable<SchemaBootstrapState>;

  constructor(
    private schemaBootstrap: SchemaBootstrapService,
    private startup: StartupService,
    private auth: AuthService,
  ) {
    this.bootstrap$ = this.schemaBootstrap.state$;
  }

  retry(): void {
    void this.startup.retryLoadSchemas();
  }

  logout(): void {
    this.auth.logout();
    this.schemaBootstrap.reset();
    this.schemaBootstrap.markNoToken();
  }
}
